import React from 'react'
import CentreImg from './Centre_img'

const Page = () => {
    return (
        <div>
            <div>
             <CentreImg/>
             </div>
            
        </div>
    )
}

export default Page
